import { connect } from "react-redux";
import ChangeMaintenanceSlot from "./changeMaintenaceSlot";
import { bindActionCreators } from "redux";
import {postTicketChangeSlot} from "services/redux/maintenance/rmTicket/action";
import {fetchPmAssignee} from "services/redux/maintenance/pmTicket/action";
import {
  fetchRmTicketDetailsForSlotChange,
} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
  pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
  rmTicketDetails: state.rmTicketReducer.rmTicketDetailsForSlot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmAssignee,
      postTicketChangeSlot,
      fetchRmTicketDetailsForSlotChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeMaintenanceSlot);
